import { CloseOutlined } from "@ant-design/icons";
import { Modal, Select, Upload } from "antd";
import React, { useState } from "react";
import { If, Then } from "react-if";

import { ErrorYellowIcon, uploadFile } from "../../assets/svg";
import { dummyRequest } from "../../helper/helpers";

import {
  uploadFileRowsLength,
  uploadFileSize,
} from "../../constants/constants";
import CustomLabel from "../customLabel";
import { FILE_TYPES } from "./constants";
import CSVLink from "./csvLink";
import "./styles.scss";

const { Dragger } = Upload;

const ImportCSVModal = (props) => {
  const {
    visible,
    hideCSVModal,
    handleCSVModal,
    listName,
    sampleFileData,
    outsideError,
  } = props;

  const [state, setState] = useState({
    fileList: [],
    file: {},
    error: false,
    uploading: false,
    sizeErr: "",
    fileType: "txtPipe",
  });

  const fileSize = uploadFileSize;
  const fileSizeError = "File size has exceeded its max limit of 8MB.";
  const rowCountError = "Row count has exceeded its max limit of 80k records";
  const updatedFileType = state?.fileType.substring(0, 3);

  const removeFile = () => {
    setState((st) => ({
      ...st,
      fileList: [],
      sizeErr: "",
    }));
  };

  const fileProps = {
    name: "file",
    listType: "picture",
    multiple: false,
    accept: `.${updatedFileType}`,
    showUploadList: {
      removeIcon: <CloseOutlined />,
    },
    customRequest: dummyRequest([updatedFileType]),
    onChange(info) {
      let list = [...info.fileList];
      list = list.map((file) => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });
      setState((st) => {
        return {
          ...st,
          fileList: list,
          error: info.file && info.file.status === "error" ? true : false,
        };
      });
    },

    onRemove: () => {
      removeFile();
    },
    beforeUpload: (file) => {
      if (file.size > fileSize) {
        setState((st) => ({
          ...st,
          sizeErr: fileSizeError,
        }));
      } else {
        return new Promise((res) => {
          const reader = new FileReader();
          reader.readAsText(file);
          reader.onload = function() {
            const match = reader.result && reader.result.match(/\r?\n/g);
            if (match && match.length >= uploadFileRowsLength) {
              setState((st) => ({
                ...st,
                sizeErr: rowCountError,
              }));
            } else {
              setState((st) => ({
                ...st,
                fileList: [file],
              }));
            }
            res(file);
          };
        });
      }
    },
    fileList: state.fileList,
    progress: {
      strokeColor: {
        "0%": "white",
        "100%": "white",
      },
      trailColor: "white",
      strokeWidth: 0,
      showInfo: false,
      success: {
        strokeColor: "white",
      },
      status: "active",
      format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
    },
  };

  const getFileDelimeter = () => {
    return FILE_TYPES?.find((fileType) => fileType.value === state.fileType)
      ?.delimeter;
  };
  return (
    <Modal
      title="Upload Data File"
      className="csv-modal"
      mask={false}
      visible={visible}
      onOk={() => {
        setState((st) => ({ ...st, uploading: true }));
        handleCSVModal(state.fileList, getFileDelimeter());
      }}
      okButtonProps={{
        disabled:
          state.uploading ||
          state.fileList.length === 0 ||
          state.error ||
          state.sizeErr,
        className:
          state.fileList.length > 0 && !state.error && !state.sizeErr
            ? ""
            : "disable-button",
      }}
      cancelButtonProps={{
        className: "cancel-button",
      }}
      onCancel={hideCSVModal}
      okText="Import"
    >
      <p className="upload-file-placeholder">
        Choose a .TXT or a .CSV file to upload {listName}’ data.
      </p>
      <span className="disclaimer-message">
        File should not exceed 8 Mb and 80k rows of data.
      </span>
      <div className={`form-row file-type-column-row `}>
        <CustomLabel title="File Type" required />
        <section className="file-type-dropdown">
          <Select
            defaultValue="txt"
            placeholder="Select File Type"
            value={state.fileType}
            onChange={(value) => {
              setState((st) => ({ ...st, fileType: value }));
              removeFile();
            }}
            options={FILE_TYPES}
          />
        </section>
      </div>
      <Dragger className="file-uploader" {...fileProps}>
        {state.fileList.length > 0 ? null : (
          <>
            <p className="ant-upload-drag-icon">{uploadFile}</p>

            <p className="ant-upload-text">
              Drag and Drop or <span className="choose-file">Choose File</span>
            </p>
          </>
        )}
      </Dragger>

      <If condition={state.sizeErr}>
        <Then>
          <section className="csv-error">
            <span className="message">
              {ErrorYellowIcon} {state.sizeErr}
            </span>
          </section>
        </Then>
      </If>

      <If condition={outsideError}>
        <Then>
          <section className="csv-error">
            <span className="message">
              {ErrorYellowIcon} {outsideError}
            </span>
          </section>
        </Then>
      </If>
      <p className="sample-file">
        Download the sample .{updatedFileType} file from{" "}
        <CSVLink
          filename={`sample.${updatedFileType}`}
          data={sampleFileData(updatedFileType)}
        >
          here
        </CSVLink>
        .
      </p>
    </Modal>
  );
};
export default ImportCSVModal;
